// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"280":"ef77605e","576":"e4051213","940":"a0c833d9"}[chunkId] + ".css";
};